import { render, staticRenderFns } from "./RelationArchive.vue?vue&type=template&id=0f494d7d&scoped=true&"
import script from "./RelationArchive.vue?vue&type=script&lang=ts&"
export * from "./RelationArchive.vue?vue&type=script&lang=ts&"
import style0 from "./RelationArchive.vue?vue&type=style&index=0&id=0f494d7d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f494d7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GDownloadButton from 'shared/global/components/DownloadButton.vue'
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {GDownloadButton,VDataTable,VFlex,VLayout,VSelect,VTextField,VTooltip})
